
import SideBar from "../components/SideBar/SideBarPlanificateur";
import "./styles-layout-doctor.scss";

const LayoutPlanificateur = ({ children }) => {

  return (
    <div className="layout-doctor flex">
       <SideBar />
      <div className="w-full pl-4">{children}</div>
    </div>
  );
};
export default LayoutPlanificateur;
